<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- Filter Toggle Button -->
<div class="filter-trigger" [style.top]="$triggerTopPosition()" [style.left]="$triggerLeftPosition()">
  <div class="action-button square-button" (click)="toggle()" [class.right]="isOpen()" [class.left]="!isOpen()">
    <div class="triangulo" [class.right]="isOpen()" [class.left]="!isOpen()"></div>
    <div class="content-img">
      <app-icon [icon]="$computedIcon()" [size]="$iconSize()" [color]="$iconColor()" />
    </div>

    <div class="content-check">
      @if ($type() !== 'list') {
      <label class="label-bg" [class.checked]="isOpen()">
        <label class="label-check" [class.checked]="isOpen()"></label>
      </label>
      }
    </div>

  </div>
</div>

<!-- Sidebar Panel -->
<div class="filter-sidebar" [class.open]="isOpen()" [class.closed]="!isOpen()" [style.width]="$sidebarWidth()"
  [style.top]="$topPosition()" [style.left]="$leftPosition()">
  <div class="sidebar-content">
    <ng-content></ng-content>
  </div>

  @if ($showButton()) {
  <div class="sidebar-footer">
    <app-button [text]="$buttonText()" [icon]="$buttonIcon()" (click)="onFilterClick()" />
  </div>
  }
</div>
